import { Injectable } from '@angular/core';
import { Device } from '@capacitor/device';

@Injectable({
  providedIn: 'root',
})
export class DeviceInfoService {
  deviceInfo: any;

  constructor() {
    Device.getInfo().then((device) => {
      this.deviceInfo = `${device.model}-${device.manufacturer}`;
    });
  }

  getDeviceInfo() {
    return this.deviceInfo;
  }
}
